import axios from 'axios';
import { message } from 'antd';
import { auth } from './firebase';



const tenantToBaseUrl = {
  [process.env.REACT_APP_TENANT_EMPLOYEE]: '/api/s-ind',
};

// Version from environment variable (populated from package.json)
const APP_VERSION = process.env.REACT_APP_VERSION;

// Create an Axios instance
const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'x-app-version': APP_VERSION,
    'x-app-platform': 'web',
  },
});

// Add a request interceptor
api.interceptors.request.use(
  async (config) => {
    const user = auth.currentUser;
    if (user) {
      const token = await user.getIdToken();
      config.headers.Authorization = `Bearer ${token}`;

      const tenantId = user.tenantId; // Replace with the correct path if tenantId is nested
      if (tenantId && tenantToBaseUrl[tenantId]) {
        config.baseURL = process.env.REACT_APP_API_BASE_URL + tenantToBaseUrl[tenantId];
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;
    if (response) {
      switch (response.status) {
        case 400:
          // message.error('Bad request');
          break;
        case 401:
          // message.error('Unauthorized');
          break;
        case 403:
          // message.error('Forbidden');
          break;
        case 404:
          // message.error('Not found');
          break;
        case 500:
          // message.error('Internal server error');
          break;
        default:
        // message.error('An error occurred');
      }
    } else {
      // message.error('Network error');
    }
    return Promise.reject(error);
  }
);

export const fetchJobs = () => api.get('/jobs');
export const getAssignments = () => api.get('/assignments');
export const getAssignment = (id) => api.get('/assignment/' + id);
export const getEmployee = (id) => api.get('/employee/' + id);
export const getOngoingAssignments = () => api.get('/assignments/ongoing');
export const getJobAssignments = (jobId) => api.get('/assignments/job/' + jobId);

export const updateAssignment = (id, data) => api.put('/assignments/' + id + "/status", data);

export const getAssignmentDocument = (id) => api.get('/assignments/' + id + "/documents");

export const getAssignmentTimesheet = (jobId) => api.get(`/timesheets/${jobId}`);
export const approveAssignmentTimesheet = (jobId, data) => api.put(`timesheets/${jobId}/timecards/approve`, data);
export const rejectAssignmentTimesheet = (jobId, data) => api.put(`timesheets/${jobId}/timecards/rejected`, data);


// Nurse (employee) onboarding
export const putNurseProfile = (payload) => api.put('/profile', payload);
export const getNurseProfile = () => api.get('/profile');
export const getNurseUnits = () => api.get('/misc/units');
export const getNurseDocumentTypes = () => api.get('/misc/document-types');
export const listNurseDocuments = () => api.get('/compliance/documents');
export const uploadNurseDocument = (payload) => api.post('/compliance/documents', payload);
export const deleteNurseDocument = (payload) => api.delete('/compliance/documents', { data: payload });




export default api;
